import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Header.css';
import { aiAppVotesAPI } from '../utils/api';

function Header() {
  const [user, setUser] = useState(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState({ tools: false, agents: false });
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [topApps, setTopApps] = useState([]);
  const navigate = useNavigate();

  const checkAuthStatus = () => {
    const token = localStorage.getItem('accessToken');
    const userRole = localStorage.getItem('userRole');
    const userEmail = localStorage.getItem('userEmail');
    const hasAdminAccess = localStorage.getItem('hasAdminAccess') === 'true' || userRole === 'admin';
    
    if (token && userRole) {
      setUser({ role: userRole, email: userEmail, hasAdminAccess });
    } else {
      setUser(null);
    }
  };

  useEffect(() => {
    const fetchTopApps = async () => {
      try {
        const response = await aiAppVotesAPI.getTopApps(5);
        setTopApps(response.apps || []);
      } catch (err) {
        console.error('Ошибка загрузки ТОП приложений:', err);
      }
    };
    
    fetchTopApps();
  }, []);

  useEffect(() => {
    // Проверяем авторизацию при загрузке
    checkAuthStatus();

    // Слушаем изменения в localStorage
    const handleStorageChange = () => {
      checkAuthStatus();
    };

    window.addEventListener('storage', handleStorageChange);
    
    // Добавляем кастомный event listener для изменений внутри того же окна
    window.addEventListener('authStatusChanged', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('authStatusChanged', handleStorageChange);
    };
  }, []);

  // Закрытие выпадающих меню при клике вне их
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.dropdown-container')) {
        setIsDropdownOpen({ tools: false, agents: false });
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('userRole');
    localStorage.removeItem('userEmail');
    localStorage.removeItem('adminPermissions');
    localStorage.removeItem('hasAdminAccess');
    localStorage.removeItem('isFullAdmin');
    localStorage.removeItem('activeCompany');
    localStorage.removeItem('isInCompanyMode');
    localStorage.removeItem('isImpersonating');
    localStorage.removeItem('impersonatorEmail');
    localStorage.removeItem('impersonatorId');
    setUser(null);
    
    // Уведомляем другие компоненты об изменении авторизации
    window.dispatchEvent(new Event('authStatusChanged'));
    
    navigate('/login');
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
    setIsDropdownOpen({ tools: false, agents: false });
  };

  const toggleMobileMenu = () => {
    console.log('Toggle mobile menu:', !isMobileMenuOpen);
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const toggleDropdown = (type) => {
    setIsDropdownOpen(prev => ({ 
      ...prev, 
      [type]: !prev[type],
      // Закрываем другие dropdown
      ...(type === 'tools' ? { agents: false } : { tools: false })
    }));
  };

  return (
    <header className="header-container">
      <nav className="nav">
        <Link to={user ? "/dashboard" : "/login"} className="logo" onClick={closeMobileMenu} style={{display:'flex',alignItems:'center',gap:'8px',textDecoration:'none'}}>
          <img src="/aihublogo.png" alt="Логотип" width="200" height="40" style={{borderRadius:'8px'}} />
        </Link>
        
        <button 
          className="mobile-menu-button"
          onClick={toggleMobileMenu}
          aria-label="Меню"
        >
          {isMobileMenuOpen ? '✕' : '☰'}
        </button>
        
        <div className={`nav-links ${isMobileMenuOpen ? 'open' : ''}`}>
          {user ? (
            <>
              <Link to="/dashboard" className="nav-link" onClick={closeMobileMenu}>
                Личный кабинет
              </Link>
              
              <div className="dropdown-container">
                <button 
                  className="dropdown-button"
                  onClick={() => toggleDropdown('tools')}
                >
                  AI Приложения
                  <svg 
                    width="12" 
                    height="12" 
                    viewBox="0 0 12 12" 
                    fill="currentColor"
                    style={{ 
                      transform: isDropdownOpen.tools ? 'rotate(180deg)' : 'rotate(0deg)',
                      transition: 'transform 0.2s'
                    }}
                  >
                    <path d="M6 9L1.5 4.5L2.5 3.5L6 7L9.5 3.5L10.5 4.5L6 9Z"/>
                  </svg>
                </button>
                <div className={`dropdown-content ${isDropdownOpen.tools ? 'open' : ''}`}>
                  {topApps.map((app) => (
                    <Link 
                      key={app.id} 
                      to={app.route} 
                      className="dropdown-item"
                      onClick={closeMobileMenu}
                    >
                      {app.name}
                    </Link>
                  ))}
                  <Link 
                    to="/dashboard" 
                    className="dropdown-item border-t border-gray-200 mt-1 pt-1"
                    onClick={closeMobileMenu}
                  >
                    Другие приложения
                  </Link>
                </div>
              </div>
              

              
              <Link to="/ai-history" className="nav-link" onClick={closeMobileMenu}>
                История действий
              </Link>
              <Link to="/profile" className="nav-link" onClick={closeMobileMenu}>
                Профиль
              </Link>
              {user.hasAdminAccess && (
                <Link to="/admin" className="nav-link" onClick={closeMobileMenu}>
                  Админ
                </Link>
              )}
              <button 
                className="button" 
                onClick={() => { handleLogout(); closeMobileMenu(); }}
              >
                Выйти
              </button>
            </>
          ) : (
            <>
              <Link to="/login" className="nav-link" onClick={closeMobileMenu}>
                Войти
              </Link>
              <Link 
                to="/register" 
                className="nav-link" 
                onClick={closeMobileMenu}
                style={{
                  background: '#3b82f6',
                  color: 'white'
                }}
              >
                Регистрация
              </Link>
            </>
          )}
        </div>
      </nav>
    </header>
  );
}

export default Header;